import React, { useEffect } from 'react'
import { Select } from '@fs/zion-ui'
import { useQueryParams } from '@fs/zion-router'
import { SPONSOR_LEVELS } from '@fs/zion-rootstech'
import { useSponsorLevelContext } from '../../providers'
import { useOnce } from '../../hooks'

export const SponsorLevelSelect = ({ paramKey, isOpen }) => {
  const { setLevel, level } = useSponsorLevelContext()
  const { query, setQuery, removeQuery } = useQueryParams()

  const onOnce = useOnce()
  useEffect(() => {
    if (isOpen) {
      onOnce(() => {
        const existingLevel = query?.[paramKey]
        setLevel(existingLevel)
      })
    }
  }, [isOpen, onOnce, paramKey, query, setLevel])

  const onChange = ({ target: { value } }) => {
    // set to null if it is de-selected to account for nullish coalescing
    setLevel(value || null)
    if (value) {
      setQuery({ [paramKey]: value })
    } else {
      removeQuery(paramKey)
    }
  }

  return <Select label="Sponsor Level" options={SPONSOR_LEVELS} onChange={onChange} value={level} />
}
